import popover from 'bootstrap/js/src/popover';
import {sendAddToWishlistClickedEvent, sendPdpAddToWishlistClickedEvent} from '../../jquery/algolia/algolia.tracking';

class WishlistController {
    /*@ngInject*/
    constructor($log, $element, $compile, $scope, $rootScope, CommonService, WishlistService) {
        $log.debug('WishlistController initialized');
        this.$log = $log;
        this.$element = $element;
        this.$compile = $compile;
        this.$scope = $scope;
        this.commonService = CommonService;
        this.wishlistService = WishlistService;
        this.$rootScope = $rootScope;
        this.hide = true;
        this.productInWishlist = [];
        this.requestPending = false;
        this.isListingPage = false;
        // not login
        this.popoverLogin = $('.plp-popover');
        this.popoverLoginContent = $('#plp-popover');
        if (this.popoverLogin.length) {
            this.initPopOverLogin();
        }

        // max wishlist size
        this.popoverMaxSize = $('.plp-popover-maxsize .icon-wishlist--empty');
        this.popoverMaxSizeContent = $('#plp-popover-maxsize');
        if (this.popoverMaxSize.length) {
            this.initPopOverMaxSize();
        }

        this.$rootScope.$on('personalizeRequestSuccess', () => {
            this.productInWishlist = this.wishlistService.productInWishlist;
            this.hide = false;
            this.setPopOverLoginCtrl();
            this.setPopOverMaxSizeCtrl();
        });

        this.$rootScope.$on('addedToWishlist', (event, code) => {
            this.addWishlistEntry(code.code);
            this.switchWishlistIconClass(code.code, true);
            this.requestPending = false;
            this.setPopOverMaxSizeCtrl();
        });

        this.$rootScope.$on('removedFromWishlist', (event, code) => {
            this.productInWishlist = this.removeWishlistEntry(code.code);
            this.switchWishlistIconClass(code.code, false);
            this.requestPending = false;
            this.setPopOverMaxSizeCtrl();
        });

        this.$rootScope.$on('wishlistError', () => {
            this.requestPending = false;
            this.initPopOverMaxSize();  // plp, search
            this.setPopOverMaxSizeCtrl();
        });

        this.$rootScope.$on('loadMoreProductsSuccess', () => {
            if (!this.isLoggedIn()) {
                this.initPopOverLogin();
            }
            this.initPopOverMaxSize();
        });

        this.$rootScope.$on('loadAlgoliaProductsSuccess', () => {
            this.setWishlistIconClass();
            if (!this.isLoggedIn()) {
                this.initPopOverLogin();
                this.setPopOverLoginCtrl();
            }
            this.initPopOverMaxSize();
            this.setPopOverMaxSizeCtrl();
        });
    }

    setPopOverLoginCtrl() {
        if (!this.isLoggedIn()) {
            this.popoverLogin.popover('enable');
        } else {
            this.popoverLogin.popover('disable');
        }
    }

    initPopOverLogin() {
        this.popoverLogin = this.$element.find('.plp-popover');
        const placement = this.popoverLogin.data('placement') || 'auto';
        this.popoverLogin.popover({
            html: true,
            content: this.popoverLoginContent,
            placement: placement,
            trigger: 'click',
            sanitize: false
        });
    }

    setPopOverMaxSizeCtrl() {
        if (this.wishlistService.itemsQuantity >= ACC.config.wishlist.maxsize) {
            this.popoverMaxSize.popover('enable');
        } else {
            this.popoverMaxSize.popover('disable');
        }
    }

    initPopOverMaxSize() {
        this.popoverMaxSize = this.$element.find('.plp-popover-maxsize .icon-wishlist--empty');
        const placement = this.$element.find('.plp-popover').data('placement') || 'auto';
        this.popoverMaxSize.popover({
            html: true,
            content: this.popoverMaxSizeContent,
            placement: placement,
            trigger: 'click',
            sanitize: false
        });
    }

    removeWishlistEntry(code) {
        return this.productInWishlist.filter(item => item !== code);
    }

    addWishlistEntry(code) {
        if (!this.productInWishlist.includes(code)) {
            this.productInWishlist.push(code);
        }
    }

    isLoggedIn() {
        return this.wishlistService.isLoggedIn();
    }

    isHidden() {
        return this.hide;
    }

    isInWishlist(code) {
        return this.productInWishlist.includes(code);
    }

    init(code) {
        this.wishlistService.setProductCodes(code);
    }

    setListingPageType(pageType) {
        this.isListingPage = pageType;
    }

    setWishlistState($event, code, isPdp, isOneSize, firstVariantCode, hasDummyVariant) {
        $event.stopPropagation();
        $event.preventDefault();
        if (!this.isWishlistAvailable()) {
            return;
        }

        if (this.isInWishlist(code)) {
            this.removeFromWishlist(code);
        } else {
            this.addToWishlist(code);
            if (isPdp === 'true') {
                let queryID = $('body').attr('data-algolia-queryId');
                let connectedObjectIds = [];
                if (isOneSize === 'true') {
                    connectedObjectIds = [firstVariantCode];
                    if (hasDummyVariant === 'true') {
                        connectedObjectIds = [firstVariantCode.slice(0, -3)];
                    }
                } else {
                    if (window.productSizes.sizes) {
                        window.productSizes.sizes.forEach(function (size) {
                            connectedObjectIds.push(size.code);
                        });
                    }
                }
                let objectID = connectedObjectIds[0];
                sendPdpAddToWishlistClickedEvent(queryID, objectID, connectedObjectIds)
            }
        }
        this.requestPending = true;
    }

    setWishlistStateAlgolia(code, queryID, objectID, connectedObjectIds) {

        if (!this.isWishlistAvailable()) {
            return;
        }

        if (this.isInWishlist(code)) {
            this.removeFromWishlist(code);
        } else {
            this.addToWishlist(code);
            sendAddToWishlistClickedEvent(queryID, objectID, connectedObjectIds)
        }
        this.requestPending = true;
    }

    isWishlistAvailable() {
        if (!this.isLoggedIn()) {
            return false;
        } else if (this.requestPending) {
            return false;
        }
        return true;
    }

    addToWishlist(code) {
        this.wishlistService.addToWishlist(code);
    }

    removeFromWishlist(code) {
        this.wishlistService.removeFromWishlist(code);
    }

    getItemsQuantity() {
        return this.wishlistService.getItemsQuantity();
    }

    setWishlistIconClass() {
        let here = this;
        this.productInWishlist.map(function (productCode) {
            here.switchWishlistIconClass(productCode, true);
        });
    }

    switchWishlistIconClass(productCode, full) {
        const wishlistCta = $('.product__wishlist-cta[data-item-code="' + productCode + '"]');
        if (!wishlistCta.length) {
            return
        }

        const data = wishlistCta[0].dataset;
        if (full) {
            wishlistCta.find('.icon-wishlist--empty').addClass('ng-hide');
            wishlistCta.find('.icon-wishlist--full').removeClass('ng-hide');
            wishlistCta.attr('aria-label', data.ariaRemove);
        } else {
            wishlistCta.find('.icon-wishlist--full').addClass('ng-hide');
            wishlistCta.find('.icon-wishlist--empty').removeClass('ng-hide');
            wishlistCta.attr('aria-label', data.ariaAdd);
        }

    }
}

export default WishlistController;
